export const actionButtonLoader = (actionbutton) => ({
  type: "ActionButtonLoader",
  payload: actionbutton,
});
